"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.InvestorsEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../../types");
var field_groups_1 = require("../../../field-groups");
var slices_1 = require("../../../slices");
var page_factory_1 = require("./page-factory");
exports.InvestorsEntity = page_factory_1.pageFactory(types_1.PageType.INVESTORS, function (prismicDoc, normalizedPage, logger) {
    var _a;
    return utils_1.compact(__assign(__assign({}, normalizedPage), { banner: field_groups_1.toBanner(utils_1.unprefix('header', prismicDoc.data), logger), body: slices_1.toSlices((_a = prismicDoc.data) === null || _a === void 0 ? void 0 : _a.body_slices, logger) }));
});
//# sourceMappingURL=investors.js.map